export const DEFAULT_AVATAR = "/images/default-avatar.png";
export const DEFAULT_FILE_ICON = "/images/file-icon.png";
export const DEFAULT_VIDEO_THUMBNAIL = "/images/video-thumbnail.png";

export const S3_ALLOWED_IMAGE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
];
export const S3_ALLOWED_DOCUMENT_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];
export const S3_ALLOWED_VIDEO_TYPES = ["video/mp4", "video/webm", "video/ogg"];

export const S3_MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
